import angular from 'angular';
import moment from 'moment';
import guid from '@/shared/utils/guid';
import { dynamicSort } from '@/shared/utils/dynamicSort';
import DocumentService from '@/shared/services/DocumentService';

angular
  .module('cloudX')
  .controller('FiscalRealEstateDialog', [
    '$http',
    'appUrls',
    'flySvc',
    'checkSecurity',
    '$element',
    'close',
    'relationId',
    'data',
    'documents',
    fiscalRealEstateDialog,
  ]);

function fiscalRealEstateDialog(
  $http,
  appUrls,
  flySvc,
  checkSecurity,
  $element,
  close,
  relationId,
  data,
  documents,
) {
  var vm = this;
  vm.saving = false;
  vm.readOnly = !checkSecurity('Relation:u');
  vm.showValidation = false;
  vm.datepickerOptions = {
    startingDay: 1,
    initDate: moment
      .utc()
      .startOf('day')
      .toDate(),
  };
  vm.relationId = relationId;
  vm.documentsAccessor = {};
  vm.documentLinkType = 10;
  vm.documents = [...(documents || [])];
  vm.documentsChanged = false;
  vm.onDocumentsChanged = function() {
    vm.documentsChanged = true;
  };
  vm.item = angular.extend(
    {
      relationId: relationId,
      amount: null,
      remark: null,
      cadastralIncome: null,
      monthlyRent: null,
      parcelNumber: null,
      vatDeductionPercentage: null,
      dateOfFirstUse: null,
      leaseholdEstateEndDate: null,
    },
    data,
  );

  vm.save = function() {
    if (vm.form.$invalid) return '';
    if (vm.saving) return '';

    vm.saving = true;
    $http.post(`${appUrls.api}/api/Fiscal/RealEstate`, vm.item).then(
      function({ data }) {
        if (typeof data.dateOfFirstUse === 'string')
          data.dateOfFirstUse = moment.utc(data.dateOfFirstUse.substr(0, 10)).toDate();
        if (typeof data.leaseholdEstateEndDate === 'string')
          data.leaseholdEstateEndDate = moment
            .utc(data.leaseholdEstateEndDate.substr(0, 10))
            .toDate();
        if (data.id) {
          vm.item.id = data.id;
          if (vm.documentsAccessor && vm.documentsAccessor.uploadNewDocuments) {
            return vm.documentsAccessor.uploadNewDocuments(data.id).then(changed => {
              vm.saving = false;
              flySvc.success();

              close([data, changed || vm.documentsChanged ? vm.documents : null], 500);
              $element.modal('hide');
            });
          }
        }
        vm.saving = false;
        flySvc.success();
        close([data, vm.documentsChanged ? vm.documents : null], 500);
        $element.modal('hide');
      },
      function(error) {
        vm.saving = false;
        flySvc.error(error);
        return '';
      },
    );
  };
  vm.cancel = function() {
    close([null, vm.documentsChanged ? vm.documents : null], 500);
  };
}
